import { loginFetchEpic } from './container/Login/logic';
import { logoutFetchEpic } from './container/Logout/logic';

export default {
  loginFetchEpic,
  logoutFetchEpic,
};
